import OptionsBusqueda from './OptionsBusqueda';
export default OptionsBusqueda;